import { useEffect, useState } from "react";
import {
  getSiteSettings,
  loadSiteSettings,
  subscribeSiteSettings,
  type SiteSettings,
} from "@/lib/publicSettings";

/** Brand, navigation, footer and hero content — read from the backend, with the
 *  curated content as an instant fallback so the shell never renders blank. */
export function useSiteSettings(): SiteSettings {
  const [settings, setSettings] = useState<SiteSettings>(getSiteSettings());

  useEffect(() => {
    let active = true;
    const unsubscribe = subscribeSiteSettings((next) => {
      if (active) setSettings(next);
    });
    loadSiteSettings().then((next) => {
      if (active) setSettings(next);
    });
    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return settings;
}